module.exports = __webpack_public_path__ + "static/media/comment.a0893b58.svg";